const MARKDOWN_HELP = `
# Custom Script (Sandbox)

Custom Script 기능을 사용하면 **JavaScript를 이용하여 데이터 변환 및 처리**를 수행할 수 있습니다.  
이 기능은 샌드박스 환경에서 실행되므로, 외부 네트워크 요청이나 제한된 API 접근은 허용되지 않습니다.

## 🛠 사용 방법

1. **스크립트 입력**: JavaScript 코드를 작성하여 입력 데이터를 변환할 수 있습니다.
2. **입력값 활용**: \`input\` 변수로 전달된 데이터를 가공할 수 있습니다.
3. **결과 반환**: 변환된 데이터를 반드시 \`return\`을 사용하여 반환해야 합니다.

## 📌 예제 1: 대문자로 변환
\`\`\`javascript
return input.toUpperCase();
\`\`\`

## 📌 예제 2: 날짜 포맷 변경
\`\`\`javascript
const date = new Date(input);
return date.toISOString().split('T')[0];
\`\`\`

## 📌 예제 3: JSON 데이터 변환
\`\`\`javascript
const obj = JSON.parse(input);
return obj.name + " - " + obj.value;
\`\`\`

## ⚠ 주의 사항
- 외부 네트워크 요청 (\`fetch\`, \`XMLHttpRequest\`)은 사용할 수 없습니다.
- 무한 루프 또는 과도한 연산을 수행하면 실행이 제한될 수 있습니다.
- 샌드박스 환경에서 실행되므로 일부 JS API가 제한될 수 있습니다.

💡 **자신만의 변환 로직을 직접 작성하여 유연하게 데이터를 가공하세요!**
`

export const CustomScript = {
  name: 'custom-script',
  label: 'Custom Script (Sandbox)',
  specifications: [
    {
      type: 'script',
      name: 'script',
      label: 'script'
    }
  ],
  help: MARKDOWN_HELP
}
